import { render, staticRenderFns } from "./exam-result-wait.vue?vue&type=template&id=e8779aec"
import script from "./exam-result-wait.vue?vue&type=script&lang=js"
export * from "./exam-result-wait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports